// extracted by mini-css-extract-plugin
export var cell = "newsletter-table-module--cell--5bba9";
export var cell__first = "newsletter-table-module--cell__first--b0645";
export var row = "newsletter-table-module--row--f9b09";
export var row__black = "newsletter-table-module--row__black--4f3ba";
export var row__bloodorange = "newsletter-table-module--row__bloodorange--b1d06";
export var row__chartruse = "newsletter-table-module--row__chartruse--85d35";
export var row__cobalt = "newsletter-table-module--row__cobalt--8c2fb";
export var row__emerald = "newsletter-table-module--row__emerald--87ed4";
export var row__heading = "newsletter-table-module--row__heading--36682";
export var row__paper = "newsletter-table-module--row__paper--f6ad2";
export var row__pink = "newsletter-table-module--row__pink--29de8";
export var row__sky = "newsletter-table-module--row__sky--d9564";
export var row__white = "newsletter-table-module--row__white--863dc";
export var spin = "newsletter-table-module--spin--16e78";
export var table = "newsletter-table-module--table--b3b7e";
export var wrapper = "newsletter-table-module--wrapper--fc414";